<div class="close-btn" mat-icon-button aria-label="close dialog" mat-dialog-close>
  <!-- <mat-icon><div class="close"><img src="/icons/close-kb.svg" alt="" width="20" height="20" /></div></mat-icon> -->
  <cx-icon [type]="iconType.CLOSE"></cx-icon>
</div>
<div mat-dialog-content>
  <div id="panzoom-element" #panzoomElement>
    <pan-zoom [config]="panZoomConfig" #panzoom>
      <div class="image-zoom-css">
        <img [src]="imageUrl" />
      </div>
    </pan-zoom>
  </div>
</div>
<div class="navigationBtn" mat-dialog-actions>
  <div class="View360-navigationZoomIn View360-navigationBtn" (click)="zoomIn()"></div>
  <div class="View360-navigationZoomOut View360-navigationBtn" (click)="zoomOut()"> </div>
  <div class="View360-navigationFullscreenEnter View360-navigationBtn tgleBtn" (click)="toggleFullScreen()">
  </div>
</div>